module.exports = __webpack_public_path__ + "static/media/imgcanto.93b8d3d3.svg";